<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="PagamentoGuias"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <SelecionarUnidade
              mostrar-todos
              @atualizar="filtro.unidade = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label>Período</label>
              <select
                v-model="filtro.mesAno"
                data-test-id="select-filtro-mesano"
                class="form-control"
                @change="aoAlterarPeriodo"
              >
                <option disabled value="">Selecione o período</option>
                <option value="custom">Período personalizado</option>
                <option
                  v-for="opcao in opcoesMessAno"
                  :key="opcao.valor"
                  :value="opcao.valor"
                >
                  {{ opcao.texto }}
                </option>
              </select>
            </div>
          </div>
          <div
            v-if="filtro.mesAno === 'custom'"
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
          >
            <SelecionarData
              label="Data Início"
              :validacao="v$.filtro.dataInicio"
              :valor="filtro.dataInicio"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div
            v-if="filtro.mesAno === 'custom'"
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
          >
            <SelecionarData
              label="Data Fim"
              :validacao="v$.filtro.dataFim"
              :valor="filtro.dataFim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <SelecionarEspecialidade @atualizar="especialidade = $event" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <BuscarSelecionarProfissional
              :minimo="1"
              label="Profissional"
              @selecionadoProfissional="profissionalId = $event._id"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label>Filtro Gestante</label>
              <select
                v-model="gestante"
                data-test-id="select-filtro-gestante"
                class="form-control"
              >
                <option value="">Todos</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <label>Filtrar por </label>
              <button
                data-test-id="button-toggle-filtrarporunicaguia-toggle-filtrarporunicaguia-2"
                type="button"
                class="btn"
                :class="
                  toggle.filtrarPorUnicaGuia ? 'btn-success' : 'btn-default'
                "
                style="
                  margin-left: 5px;
                  padding: 2px 10px;
                  font-size: 13px;
                  height: 28px;
                  line-height: 1.2;
                  vertical-align: middle;
                "
                @click="
                  toggle.filtrarPorUnicaGuia = !toggle.filtrarPorUnicaGuia
                "
              >
                {{ toggle.filtrarPorUnicaGuia ? 'Guia' : 'Multiplas Guias' }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="toggle.filtrarPorUnicaGuia" class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <BuscarSelecionarGuia
              :minimo="1"
              :exibe-label="false"
              :disabled="toggle.filtrarPorUnicaGuia"
              @selecionadoGuia="numeroGuia = $event.autorizacao.numeroGuia"
            />
          </div>
        </div>

        <div v-if="!toggle.filtrarPorUnicaGuia" class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <textarea
                v-model="filtro.numerosGuias"
                data-test-id="textarea-filtro-numerosguias"
                class="form-control"
                rows="4"
                placeholder="Exemplo:
1712002517
1712002551
1712002589"
              ></textarea>
              <small class="text-muted">Um número de guia por linha</small>
            </div>
          </div>
        </div>

        <br />

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <label>Convênios</label>
              <div class="convenios-header">
                <button
                  data-test-id="button-marcartodosconvenios-4"
                  type="button"
                  class="btn btn-sm btn-default"
                  @click="marcarTodosConvenios"
                >
                  {{
                    todosConveniosMarcados ? 'Desmarcar Todos' : 'Marcar Todos'
                  }}
                </button>
              </div>
              <div class="convenios-checkbox-container">
                <div v-if="convenios.length === 0" class="text-muted">
                  Carregando convênios...
                </div>
                <div
                  v-for="convenio in convenios"
                  :key="convenio._id"
                  class="convenio-checkbox"
                >
                  <label>
                    <input
                      v-model="conveniosSelecionados"
                      data-test-id="input-conveniosselecionados"
                      type="checkbox"
                      :value="convenio.nome"
                    />
                    {{ convenio.nome }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="checkbox">
              <label>
                <input
                  v-model="filtro.exibirGuiasSemFaturamento"
                  data-test-id="input-filtro-exibirguiassemfaturamento"
                  type="checkbox"
                />
                Exibir {{ semFaturamento || '' }} guias sem faturamento
              </label>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="checkbox">
              <label>
                <input
                  v-model="filtro.exibirGuiasCompletas"
                  data-test-id="input-filtro-exibirguiascompletas"
                  type="checkbox"
                />
                Exibir guias totalmente faturadas
              </label>
            </div>
          </div>
        </div>
        <br />
      </template>
    </BlocoFiltroPesquisa>
    <div class="relatorio-main">
      <div v-if="!carregando && !comFaturamento && !semFaturamento" class="row">
        <div class="well">
          <h3>Nenhum dado encontrado</h3>
        </div>
      </div>

      <div>
        <div v-if="comFaturamento" class="row">
          <h3
            class="relatorio-cabecalho"
            @click="toggle.comFaturamento = !toggle.comFaturamento"
          >
            Guias com faturamento ({{ comFaturamento }})
            <span
              :class="`fa ${toggle.comFaturamento ? 'fa-caret-down' : 'fa-caret-up'}`"
            />
          </h3>
          <br />
        </div>
        <div v-if="comFaturamento && toggle.comFaturamento" class="row">
          <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div
              v-for="(item, index) in resultado.guiasComFaturamento"
              id="panels"
              :key="item.numero_guia"
              class="panel-group"
              role="tablist"
              aria-multiselectable="true"
            >
              <div
                class="panel panel-primary"
                :class="{ 'guia-completa': isGuiaCompleta(item) }"
              >
                <div :id="'item' + index" class="panel-heading" role="tab">
                  <span class="cabecalho-guia">
                    <span>{{ item.numero_guia }}</span>
                    <span class="pull-right cabecalho-guia">
                      <strong>Total de sessões:</strong>
                      <span
                        :class="{ 'sessoes-completas': isGuiaCompleta(item) }"
                        class="sessoes-badge"
                      >
                        {{ item.total_sessoes }} / {{ item.total_sessoes_guia }}
                      </span>
                      <i
                        v-if="isGuiaCompleta(item)"
                        class="fa fa-check-circle guia-completa-icon"
                      ></i>
                    </span>
                  </span>
                </div>
                <div class="panel-collapse">
                  <table class="table table-striped table-hover table-bordered">
                    <thead>
                      <tr style="background-color: #008080; color: white">
                        <td class="text-center tabela-head"
                          >Nome do paciente</td
                        >
                        <td class="text-center tabela-head">Especialidade</td>
                        <td class="text-center tabela-head">Unidade</td>
                        <td class="text-center tabela-head">Convênio</td>
                        <td class="text-center tabela-head">Procedimentos</td>
                        <td class="text-center tabela-head">Profissionais</td>
                        <td class="text-right tabela-head"
                          >Total enviado (R$)</td
                        >
                        <td class="text-right tabela-head">Total glosa (R$)</td>
                        <td class="text-right tabela-head">Total pago (R$)</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center cell">{{ item.paciente }}</td>
                        <td class="text-center cell">{{
                          item.especialidade
                        }}</td>
                        <td class="text-center cell">{{ item.unidade }}</td>
                        <td class="text-center cell">{{ item.convenio }}</td>
                        <td class="cell">
                          <ul
                            v-if="
                              item.procedimentos &&
                              item.procedimentos.length > 0
                            "
                          >
                            <li
                              v-for="procedimento in item.procedimentos"
                              :key="procedimento"
                            >
                              {{ procedimento }}
                            </li>
                          </ul>
                        </td>
                        <td class="cell">
                          <ul
                            v-if="
                              item.profissionais &&
                              item.profissionais.length > 0
                            "
                          >
                            <li
                              v-for="profissional in item.profissionais"
                              :key="profissional._id"
                            >
                              {{ profissional.nome }}
                            </li>
                          </ul>
                        </td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_enviado)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_glosa)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_pago)
                        }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="filtro.exibirGuiasSemFaturamento && semFaturamento"
          class="row"
        >
          <h3
            class="relatorio-cabecalho"
            @click="toggle.semFaturamento = !toggle.semFaturamento"
          >
            Guias sem faturamento ({{ semFaturamento }})
            <span
              :class="`fa ${toggle.semFaturamento ? 'fa-caret-down' : 'fa-caret-up'}`"
            />
          </h3>
          <br />
        </div>
        <div
          v-if="
            filtro.exibirGuiasSemFaturamento &&
            semFaturamento &&
            toggle.semFaturamento
          "
          class="row"
        >
          <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div
              v-for="(item, index) in resultado.guiasSemFaturamento"
              id="panels"
              :key="item.numero_guia"
              class="panel-group"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-primary">
                <div :id="'item' + index" class="panel-heading" role="tab">
                  <span class="cabecalho-guia">
                    <span>{{ item.numero_guia }}</span>
                    <span class="pull-right cabecalho-guia">
                      <strong>Total de sessões:</strong>
                      {{ item.total_sessoes }}
                    </span>
                  </span>
                </div>
                <div class="panel-collapse">
                  <table class="table table-striped table-hover table-bordered">
                    <thead>
                      <tr style="background-color: #008080; color: white">
                        <td class="text-center tabela-head"
                          >Nome do paciente</td
                        >
                        <td class="text-center tabela-head">Especialidade</td>
                        <td class="text-center tabela-head">Unidade</td>
                        <td class="text-center tabela-head">Convênio</td>
                        <td class="text-center tabela-head">Procedimento</td>
                        <td class="text-center tabela-head">Profissionais</td>
                        <td class="text-right tabela-head"
                          >Total enviado (R$)</td
                        >
                        <td class="text-right tabela-head">Total glosa (R$)</td>
                        <td class="text-right tabela-head">Total pago (R$)</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center cell">{{ item.paciente }}</td>
                        <td class="text-center cell">{{
                          item.especialidade
                        }}</td>
                        <td class="text-center cell">{{ item.unidade }}</td>
                        <td class="text-center cell">{{ item.convenio }}</td>
                        <td class="cell">{{ item.procedimento }}</td>
                        <td class="cell">
                          <ul
                            v-if="
                              item.profissionais &&
                              item.profissionais.length > 0
                            "
                          >
                            <li
                              v-for="profissional in item.profissionais"
                              :key="profissional._id"
                            >
                              {{ profissional.nome }}
                            </li>
                          </ul>
                        </td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_enviado)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_glosa)
                        }}</td>
                        <td class="text-right cell">{{
                          formatarDinheiro(item.total_pago)
                        }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BuscarSelecionarGuia from '@/componentes/formulario/BuscarSelecionarGuia'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import ConvenioServico from '@/servicos/ConvenioServico'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'
import UnidadeServico from '@/servicos/UnidadeServico'
import * as formatadores from '@/utils/formatadores'

const unidadeServico = new UnidadeServico()
const mensagemServico = new MensagemServico()
const relatorioServico = new RelatorioServico()
const convenioServico = new ConvenioServico()

export default {
  components: {
    BlocoFiltroPesquisa,
    BuscarSelecionarProfissional,
    BuscarSelecionarGuia,
    SelecionarEspecialidade,
    SelecionarUnidade,
    SelecionarData,
  },
  directives: { mask: AwesomeMask },
  setup() {
    useMenu(72)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      carregando: false,
      unidades: [],
      toggle: {
        comFaturamento: true,
        semFaturamento: true,
        filtrarPorUnicaGuia: true,
      },
      especialidade: '',
      profissionalId: '',
      gestante: '',
      numeroGuia: null,
      convenios: [],
      conveniosSelecionados: [],
      filtro: {
        unidade: '',
        mesAno: moment().format('YYYY-MM'),
        dataInicio: moment().startOf('month'),
        dataFim: moment().endOf('month'),
        exibirGuiasSemFaturamento: false,
        exibirGuiasCompletas: false,
        numerosGuias: '',
      },
      resultado: {
        guiasComFaturamento: [],
        guiasSemFaturamento: [],
      },
    }
  },
  computed: {
    todosConveniosMarcados() {
      return (
        this.convenios.length > 0 &&
        this.conveniosSelecionados.length === this.convenios.length
      )
    },
    comFaturamento() {
      return this.resultado.guiasComFaturamento.length
    },
    semFaturamento() {
      return this.resultado.guiasSemFaturamento.length
    },
    opcoesMessAno() {
      const opcoes = []

      for (let i = 0; i < 24; i++) {
        const data = moment().subtract(i, 'months')
        opcoes.push({
          valor: data.format('YYYY-MM'),
          texto: data.format('MMMM [de] YYYY'),
        })
      }

      return opcoes
    },
    contadorGuias() {
      if (!this.filtro.numerosGuias) return 0
      return this.filtro.numerosGuias
        .split('\n')
        .filter((linha) => linha.trim().length > 0).length
    },
    listaGuiasFiltradas() {
      if (this.filtro.filtrarPorUnicaGuia || !this.filtro.numerosGuias) {
        return []
      }
      return this.filtro.numerosGuias
        .split('\n')
        .map((linha) => linha.trim())
        .filter((numero) => numero.length > 0)
    },
  },
  created() {
    this.recuperarUnidades()
    this.recuperarConvenios()
    this.pesquisar()
  },
  validations: {
    filtro: {
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    ...formatadores,
    marcarTodosConvenios() {
      if (this.todosConveniosMarcados) {
        // Desmarcar todos
        this.conveniosSelecionados = []
      } else {
        // Marcar todos
        this.conveniosSelecionados = this.convenios.map((c) => c.nome)
      }
    },
    isGuiaCompleta(item) {
      return item.total_sessoes >= item.total_sessoes_guia
    },
    aoAlternarMultiplasGuias() {
      if (!this.toggle.filtrarPorUnicaGuia) {
        this.numeroGuia = null
        this.filtro.numerosGuias = ''
      } else {
        this.filtro.numerosGuias = ''
      }
    },
    recuperarConvenios() {
      convenioServico.recuperarTodos({}).then((result) => {
        this.convenios = result.convenios.sort((a, b) =>
          a.nome.trim().localeCompare(b.nome.trim())
        )
      })
    },
    pesquisar() {
      this.resultado.guiasComFaturamento = []
      this.resultado.guiasSemFaturamento = []
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Preencha os campos corretamente.')
        return
      }

      this.carregando = true

      const params = {
        unidade: this.filtro.unidade,
        dataInicio: moment(this.filtro.dataInicio).format('YYYY-MM-DD'),
        dataFim: moment(this.filtro.dataFim).format('YYYY-MM-DD'),
      }

      if (this.gestante !== '') {
        params.isGestante = this.gestante === 'true'
      }

      relatorioServico
        .relatorioPagamentoGuia(params)
        .then((result) => {
          this.carregando = false

          const filterGuias = (items) => {
            if (!items) return []
            return items.filter(
              (g) =>
                (!this.especialidade ||
                  g.especialidade === this.especialidade) &&
                (!this.profissionalId ||
                  g.profissionais.some((p) => p._id === this.profissionalId)) &&
                // Filtro por guia única ou múltiplas guias
                (!this.toggle.filtrarPorUnicaGuia
                  ? this.listaGuiasFiltradas.length === 0 ||
                    this.listaGuiasFiltradas.includes(g.numero_guia)
                  : !this.numeroGuia || g.numero_guia === this.numeroGuia) &&
                (!this.filtro.exibirGuiasCompletas ||
                  g.total_sessoes_guia <= g.total_sessoes) &&
                // Filtro por convenio
                (this.conveniosSelecionados.length === 0 ||
                  this.conveniosSelecionados.includes(g.convenio))
            )
          }

          this.resultado.guiasComFaturamento = filterGuias(
            result.guiasComFaturamento
          )
          this.resultado.guiasSemFaturamento = filterGuias(
            result.guiasSemFaturamento
          )
        })
        .catch((error) => {
          this.carregando = false
          console.error('Erro ao buscar relatório:', error)
          mensagemServico.erro('Erro ao buscar relatório. Tente novamente.')
        })
    },
    limparFiltro() {
      this.filtro.unidade = ''
      this.filtro.dataInicio = moment().startOf('month').format('DD/MM/YYYY')
      this.filtro.dataFim = moment().endOf('month').format('DD/MM/YYYY')
    },
    recuperarUnidades() {
      unidadeServico.recuperarTodos().then((result) => {
        this.unidades = result.unidades
      })
    },
    aoAlterarPeriodo() {
      if (this.filtro.mesAno === 'custom') {
        this.filtro.dataInicio = moment().startOf('month')
        this.filtro.dataFim = moment().endOf('month')
      } else if (this.filtro.mesAno) {
        this.filtro.dataInicio = moment(this.filtro.mesAno).startOf('month')
        this.filtro.dataFim = moment(this.filtro.mesAno).endOf('month')
      } else {
        this.filtro.dataInicio = null
        this.filtro.dataFim = null
      }
    },
  },
}
</script>

<style scoped>
.convenios-header {
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-end;
}

.convenios-checkbox-container {
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.convenio-checkbox {
  width: 25%;
  padding: 5px 10px;
}

@media (max-width: 992px) {
  .convenio-checkbox {
    width: 33.33%;
  }
}

@media (max-width: 768px) {
  .convenio-checkbox {
    width: 50%;
  }
}

@media (max-width: 480px) {
  .convenio-checkbox {
    width: 100%;
  }
}
.cabecalho-guia {
  color: white;
}

.relatorio-cabecalho {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.relatorio-main {
  padding: 20px;
}

.guia-completa .panel-heading {
  background-color: #008080 !important;
  border-color: #008080 !important;
}

.sessoes-badge {
  padding: 2px 6px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.2);
  margin-left: 8px;
  font-size: 12px;
}

.sessoes-completas {
  background-color: rgba(255, 255, 255, 0.4);
  font-weight: 600;
  color: #fff;
}

.guia-completa-icon {
  margin-left: 6px;
  color: #fff;
  font-size: 14px;
}

.guia-completa .panel-body,
.guia-completa .panel-collapse {
  background-color: #f8fdfd;
}
</style>
